webpackJsonp([107818501498521],{

/***/ 219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(23);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _singleFormLayout = __webpack_require__(248);
	
	var _singleFormLayout2 = _interopRequireDefault(_singleFormLayout);
	
	var _navbar = __webpack_require__(44);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _mobileContent = __webpack_require__(70);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _formsShared = __webpack_require__(91);
	
	var _palette = __webpack_require__(17);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _color = __webpack_require__(94);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _icons = __webpack_require__(92);
	
	var _mobileDetect = __webpack_require__(87);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	__webpack_require__(219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var windowWidth = typeof window !== 'undefined' && window.innerWidth;
	var md = typeof window !== 'undefined' ? new _mobileDetect2.default(window.navigator.userAgent) : { mobile: function mobile() {
	    return false;
	  } };
	var isMobile = md.mobile();
	
	var STYLES = _extends({
	  blogHeaderWrap: {
	    backgroundColor: _palette2.default.COAL,
	    position: 'relative',
	    paddingTop: 90,
	    paddingBottom: 30,
	    color: _palette2.default.SUNSTONE,
	    textAlign: 'center',
	    '@media screen and (max-width: 1115px)': {
	      marginTop: 0
	    }
	  },
	  blogWrap: {
	    marginTop: 0,
	    width: '100%',
	    color: _palette2.default.LIGHTEST_GRAY,
	    minHeight: 200,
	    display: 'inline-block',
	    padding: '60px 10px 100px'
	  },
	  blogContentWrap: {
	    margin: '0 auto',
	    backgroundColor: 'rgb(252,252,252)',
	    borderRadius: 12,
	    width: '98%',
	    maxWidth: 980,
	    minWidth: 300,
	    padding: '20px 46px 20px',
	    minHeight: 'calc(100vh - 260px)',
	    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)'
	  },
	  keepReadingWrap: {
	    margin: '0 auto',
	    width: '98%',
	    maxWidth: 980,
	    minWidth: 300
	  },
	  link: {
	    color: _palette2.default.LIGHT_BLUE,
	    textDecoration: 'none'
	  },
	  title: {
	    color: _palette2.default.SUNSTONE
	  },
	  authorWrap: {
	    textAlign: 'center',
	    display: 'block',
	    textDecoration: 'none',
	    marginTop: -40,
	    fontSize: 16
	  },
	  authorHeadshot: {
	    backgroundColor: 'lightgrey',
	    backgroundPosition: '50% 50%',
	    backgroundRepeat: 'no-repeat',
	    borderRadius: 40,
	    height: 60,
	    left: 'calc(50% - 30px)',
	    top: -50,
	    position: 'relative',
	    width: 60,
	    margin: '0 auto'
	  },
	  authorName: {
	    fontWeight: 'bold',
	    marginTop: 7,
	    marginBottom: 0,
	    color: _palette2.default.LIGHTEST_GRAY,
	    fontSize: 16
	  },
	  authorBlurb: {
	    marginTop: -2,
	    marginBottom: 0,
	    color: (0, _color2.default)(_palette2.default.DARKER_ROCK).darken(.2),
	    fontSize: 16
	  },
	  twitterContainer: {
	    position: 'relative'
	  },
	  twitterLogo: {
	    cursor: 'pointer',
	    top: -1,
	    position: 'absolute'
	  },
	  blogPost: {
	    fontSize: 21 //TODO: mobile = 18
	  },
	  keepReadingContent: {
	    padding: 12
	  },
	  keepReadingTitle: {
	    color: _palette2.default.LIGHT_BLUE,
	    textTransform: 'uppercase',
	    fontSize: 22,
	    marginTop: 5,
	    marginBottom: 5
	  },
	  keepReadingSubtitle: {
	    color: _palette2.default.SUNSTONE,
	    marginTop: 80
	  },
	  keepReadingAuthorWrap: {
	    display: 'block',
	    textDecoration: 'none',
	    position: 'relative',
	    minHeight: 50
	  },
	  keepReadingAuthorHeadshot: {
	    backgroundColor: 'lightgrey',
	    backgroundPosition: '50% 50%',
	    backgroundRepeat: 'no-repeat',
	    borderRadius: 20,
	    position: 'absolute',
	    height: 40,
	    left: 0,
	    bottom: 0,
	    width: 40
	  },
	  keepReadingAuthorName: {
	    position: 'absolute',
	    bottom: 8,
	    left: 50,
	    marginBottom: 0,
	    color: _palette2.default.SUNSTONE,
	    fontSize: 16
	  },
	  tag: {
	    fontSize: 14,
	    background: _palette2.default.LIGHTEST_PINK,
	    color: _palette2.default.SUNSTONE,
	    borderRadius: 4,
	    padding: 5,
	    marginTop: 15,
	    display: 'inline-block'
	  }
	}, _formsShared.FORM_STYLES);
	
	var Template = function (_Component) {
	  _inherits(Template, _Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    setTimeout(function () {
	      window.scrollTo(0, 0);
	    });
	  };
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathContext = _props.pathContext;
	    var post = data.markdownRemark; // data.markdownRemark holds our post data
	
	    var next = pathContext.next,
	        prev = pathContext.prev;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Haiku Blog - ' + post.frontmatter.title
	        ),
	        post.excerpt && _react2.default.createElement('meta', { name: 'description', content: post.excerpt }),
	        post.frontmatter.canonicalUrl && _react2.default.createElement('link', { rel: 'canonical', href: post.frontmatter.canonicalUrl }),
	        post.frontmatter.title && _react2.default.createElement('meta', { property: 'og:title', content: post.frontmatter.title }),
	        post.excerpt && _react2.default.createElement('meta', { property: 'og:description', content: post.excerpt }),
	        post.frontmatter.coverImage.publicURL && _react2.default.createElement('meta', { property: 'og:image', content: '' + ("https://www.haiku.ai") + post.frontmatter.coverImage }),
	        post.frontmatter.path && _react2.default.createElement('meta', { property: 'og:url', content: '' + ("https://www.haiku.ai") + post.frontmatter.path })
	      ),
	      _react2.default.createElement(_navbar2.default, { location: 'blog' }),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            margin: '0 auto',
	            width: '100%'
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.blogHeaderWrap },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { style: STYLES.title, to: '/blog/' },
	            _react2.default.createElement(_icons.HaikuIconGradioSVG, { width: 80, height: 80 }),
	            _react2.default.createElement(
	              'h2',
	              { style: { marginTop: 20 } },
	              'Haiku Blog'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.blogWrap },
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.blogContentWrap },
	            _react2.default.createElement(
	              'div',
	              { className: 'blog-post-container' },
	              _react2.default.createElement('img', { src: post.frontmatter.authorHeadshot, style: STYLES.authorHeadshot, alt: post.frontmatter.authorName }),
	              _react2.default.createElement(
	                'div',
	                { style: STYLES.authorWrap },
	                _react2.default.createElement(
	                  'div',
	                  { style: STYLES.authorName },
	                  post.frontmatter.authorName,
	                  post.frontmatter.twitterLink && _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: post.frontmatter.twitterLink, style: STYLES.twitterContainer },
	                    _react2.default.createElement(
	                      'span',
	                      { style: STYLES.twitterLogo },
	                      _react2.default.createElement(_icons.TwitterSVG, { color: 'rgb(72,160,236)' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: STYLES.authorBlurb },
	                  post.frontmatter.authorBlurb
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'blog-post', style: STYLES.blogPost },
	                _react2.default.createElement(
	                  'div',
	                  { style: { textAlign: 'center', marginTop: 0 } },
	                  _react2.default.createElement(
	                    'h1',
	                    null,
	                    post.frontmatter.title
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: STYLES.authorBlurb },
	                    post.frontmatter.date,
	                    post.frontmatter.readLength && _react2.default.createElement(
	                      'span',
	                      null,
	                      ' - ',
	                      post.frontmatter.readLength,
	                      ' min read'
	                    )
	                  ),
	                  post.frontmatter.tags && post.frontmatter.tags.map(function (tag) {
	                    return _react2.default.createElement(
	                      'span',
	                      { style: STYLES.tag },
	                      tag
	                    );
	                  })
	                ),
	                _react2.default.createElement('div', {
	                  className: 'blog-post-content',
	                  dangerouslySetInnerHTML: { __html: post.html }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.keepReadingWrap },
	            _react2.default.createElement(
	              'div',
	              { className: 'keep-reading' },
	              next && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  { style: STYLES.keepReadingSubtitle },
	                  'Previous Post'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'link next', to: next.path },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'keep-reading-block', style: STYLES.keepReading },
	                    _react2.default.createElement('img', { className: 'blogFeatureImage', src: next.coverImage.publicURL, alt: next.title }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: STYLES.keepReadingContent },
	                      _react2.default.createElement(
	                        'p',
	                        { style: STYLES.keepReadingTitle },
	                        next.title
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: STYLES.keepReadingAuthorWrap },
	                        _react2.default.createElement('img', { src: next.authorHeadshot, style: STYLES.keepReadingAuthorHeadshot, alt: next.authorName }),
	                        _react2.default.createElement(
	                          'p',
	                          { style: STYLES.keepReadingAuthorName },
	                          next.authorName
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              prev && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  { style: STYLES.keepReadingSubtitle },
	                  'Next Post'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'link prev', to: prev.path },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'keep-reading-block', style: STYLES.keepReading },
	                    _react2.default.createElement('img', { className: 'blogFeatureImage', src: prev.coverImage.publicURL, alt: prev.title }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: STYLES.keepReadingContent },
	                      _react2.default.createElement(
	                        'p',
	                        { style: STYLES.keepReadingTitle },
	                        prev.title
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: STYLES.keepReadingAuthorWrap },
	                        _react2.default.createElement('img', { src: prev.authorHeadshot, style: STYLES.keepReadingAuthorHeadshot, alt: prev.authorName }),
	                        _react2.default.createElement(
	                          'p',
	                          { style: STYLES.keepReadingAuthorName },
	                          prev.authorName
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_mobileContent2.default, null)
	    );
	  };
	
	  return Template;
	}(_react.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-04bc8981846ff0b14f28.js